module.exports = __webpack_public_path__ + "static/media/wedding4.17a54c6f.jpg";